import React from 'react';
import { Button, Breadcrumbs, BreadcrumbItem } from '@heroui/react';
import { useBreadcrumbs } from '../contexts/BreadcrumbContext';
import { useNavigate } from 'react-router';
import { useTranslations } from '../contexts/translation.context';
import IcTg from './ic-telegram.svg';
import { LanguageSwitcher } from './LanguageSwitcher';

const Header: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslations();

  const handleBreadcrumbClick = (href: string) => {
    if (href) {
      navigate(href);
    }
  };
  const { breadcrumbs } = useBreadcrumbs();
  return (
    <nav className="flex items-end justify-between  p-[24px]">
      {/* Breadcrumbs */}
      <div className='flex items-center justify-between w-full'>
        <div className="flex items-center">
          {breadcrumbs.length > 0 && (
            <Breadcrumbs 
              separator="/"
              
            >
              {breadcrumbs.map((item, index) => (
                <BreadcrumbItem 
                  key={item.href || index}
                  classNames={{
                    separator: "text-[#888B8D] px-[16px]",
                    item: item.isActive ? "text-[#888B8D] cursor-default" : "text-[#000000] cursor-pointer hover:text-[#006FEE]",
                  }}
                  isLast={item.isActive}
                  isCurrent={item.isActive}
                  onClick={() => !item.isActive && item.href && handleBreadcrumbClick(item.href)}
                >
                  {item.label}
                </BreadcrumbItem>
              ))}
            </Breadcrumbs>
          )}
        </div>
        <div/>
      </div>
    </nav>
  );
};

export default Header; 
